import { FC } from 'react'
import { Box, Button } from '@mui/material'

export interface BulkInvoicesStepperFooterProps {
  showPrev: boolean
  prevDisabled?: boolean
  nextLabel: string
  nextDisabled?: boolean
  onPrev: () => void
  onNext: () => void
}

export const BulkInvoicesStepperFooter: FC<BulkInvoicesStepperFooterProps> = ({
  showPrev,
  prevDisabled = false,
  nextLabel,
  nextDisabled = false,
  onPrev,
  onNext,
}) => {
  return (
    <Box
      sx={{
        position: 'sticky',
        bottom: 0,
        zIndex: 10,
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 2,
        px: 2,
        py: 1.5,
        mt: 'auto',
        backgroundColor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      {showPrev && (
        <Button variant="outlined" disabled={prevDisabled} onClick={onPrev}>
          Prev
        </Button>
      )}
      <Button
        variant="contained"
        disabled={nextDisabled}
        onClick={onNext}
        sx={
          nextLabel.startsWith('Create') || nextLabel === 'View Invoices'
            ? { backgroundColor: '#37A239', '&:hover': { backgroundColor: '#2d8a2f' } }
            : undefined
        }
      >
        {nextLabel}
      </Button>
    </Box>
  )
}

export default BulkInvoicesStepperFooter
